"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _reactForm = _interopRequireDefault(require("@micado-digital/react-form"));
var _formContext = _interopRequireDefault(require("@micado-digital/react-form/context/formContext"));
var _Input = _interopRequireDefault(require("@micado-digital/react-form/Input"));
var _Button = _interopRequireDefault(require("@micado-digital/react-form/Button"));
var _Message = _interopRequireDefault(require("@micado-digital/react-form/Message"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Form = _interopRequireDefault(require("./Form.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FormContent = _ref => {
  let {
    lang,
    token
  } = _ref;
  const [formConfig] = (0, _react.useContext)(_formContext.default);
  const {
    errorFields = {},
    formLocked,
    response: {
      data: {
        msg: formMsg
      } = {}
    } = {}
  } = formConfig;
  const [formMessageObj, setFormMessageObj] = (0, _react.useState)({});
  const navigate = (0, _useLink.default)();
  const css = (0, _Form.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    if (!formMsg) return;
    switch (formMsg) {
      case "ok":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.success.ACCESSCODE_SEND",
              l: l
            }),
            type: "success"
          });
          setTimeout(() => {
            navigate("/".concat(lang, "/shop/digital-product?token=").concat(token));
          }, 3000);
          break;
        }
      case "parameter_missing":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.ACCESSCODE_NOT_SEND",
              l: l
            }),
            type: "error"
          });
          break;
        }
      case "limit_reached":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.ACCESSCODE_LIMIT_REACHED",
              l: l
            }),
            type: "error"
          });
          break;
        }
      case "not_allowed":
      default:
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.ACCESSCODE_NOT_ALLOWED",
              l: l
            }),
            type: "error"
          });
          break;
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formConfig]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["email"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.digitalProductAuthentication.requiredField",
      l: l
    }),
    label: l("reactShop.digitalProductAuthentication.email"),
    name: "email",
    required: true,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["token"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.digitalProductAuthentication.requiredField",
      l: l
    }),
    label: l("reactShop.digitalProductAuthentication.token"),
    name: "token",
    required: true,
    value: token,
    TextfieldProps: {
      variant: "outlined"
    }
  }), !(0, _isEmpty.default)(formMessageObj) && formMessageObj.message && /*#__PURE__*/_react.default.createElement(_Message.default, {
    text: formMessageObj.message,
    type: formMessageObj.type
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.button, "mco-shop-digital-product-authentication-form__button")
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    label: l("reactShop.digitalProductAuthentication.buttons.save"),
    locked: formLocked,
    ButtonProps: {
      color: "primary",
      variant: "contained"
    },
    type: "submit"
  })));
};
const Form = _ref2 => {
  let {
    lang,
    onSubmit
  } = _ref2;
  const {
    REACT_APP_PATH
  } = process.env;
  const {
    search
  } = (0, _reactRouterDom.useLocation)();
  const css = (0, _Form.default)();
  const params = new URLSearchParams(search);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.form, "mco-shop-digital-product-authentication-form")
  }, /*#__PURE__*/_react.default.createElement(_reactForm.default, {
    action: "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.DigitalProductApi/SendAccessCodeMail.api"),
    method: "POST",
    contentType: "formData",
    onAfterSubmit: data => {
      if (onSubmit) onSubmit(data);
    }
  }, /*#__PURE__*/_react.default.createElement(FormContent, {
    lang: lang,
    token: params.get("token")
  })));
};
var _default = exports.default = Form;